import { ProductCollectionGroupsEnum } from "../../../../shared/enums/product-collection-groups-enum";
import {ProductCollectionsEnum} from "../../../../shared/enums/product-collections.enum";
import {AggregationsValueModel} from "../../../../shared/models/search/aggregations/aggregations-value.model";
import {EmptySearchParamsFilterModel} from "../../../../shared/models/search/params/filters/empty-search-params-filter.model";

export class ProductsParamsFilter extends EmptySearchParamsFilterModel {
    public constructor(
        public collectionGroup: ProductCollectionGroupsEnum,
        public collection: ProductCollectionsEnum,
        public facets: AggregationsValueModel,
        public sorting: string
    ) {
        super();
    }
}
